module.exports = __webpack_public_path__ + "img/tooltip_04-vallone-nano-black.015902b9.jpg";